import { api } from '../../../plugins/axios';

export default class ShippingReturnReason {
	id = null;
	title = null;
    prevTitle = null;
	created_at = null;
	updated_at = null;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
        this.prevTitle = this.title;
	}

	static async getReasons(params = {}) {
		const res = await api.get('shipping/return-reasons', {
			params,
		});
		const data = res.data.result.return_reasons;

		return {
			data: data.data.map((item) => new ShippingReturnReason(item)),
			totalRecords: data.total,
		};
	}

	static async createReason(data) {
		const res = await api.post('/shipping/return-reasons', data);
		const reason = new ShippingReturnReason(res.data.result.return_reason);
		return reason;
	}

	async update(data) {
		const res = await api.put(`/shipping/return-reasons/${this.id}`, data);
		const reason = new ShippingReturnReason(res.data.result.return_reason);
		Object.assign(this, reason);
	}

	async deleteReason() {
		return api.delete(`/shipping/return-reasons/${this.id}`);
	}
}
